import { render, staticRenderFns } from "./LivingOptionPolygons.vue?vue&type=template&id=3b4d9e08&scoped=true&"
import script from "./LivingOptionPolygons.vue?vue&type=script&lang=js&"
export * from "./LivingOptionPolygons.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptionPolygons.vue?vue&type=style&index=0&id=3b4d9e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d9e08",
  null
  
)

export default component.exports